// ** Router Import
import Router from './router/Router';
// ** React Query Import
import { QueryClientProvider, QueryClient } from 'react-query';
import { SocketProvider } from './utility/context/Socket';

import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getCommunityDetailsAction, getProfileAction } from './views/community/store/action';
import { fetchUserApi, handleLogout } from './redux/authentication';
import { useHistory } from 'react-router-dom';
import ls from '@livesession/sdk';

const urlsNotInclude = [
  '/login',
  '/register',
  '/signup',
  '/community/',
  '/community/shop/',
  '/community/refer/',
  '/community/home/',
  '/community/message/',
  '/community/calendar/',
  '/community/orgchart',
  '/community/members/',
  '/community/myrefer',
  '/community/checkin',
  '/community/group/',
  '/community/profile/',
  '/community/dashboard/',
  '/community/events/',
  '/community/course/',
  '/community/shop/product-details/p/',
  '/events/',
  '/events/p/',
  '/community/refer/',
  '/community/group-details/p/',
  '/tournaments/p/',
  '/community/members/p/',
  '/community/messenger/',
  '/community/inbox/',
  '/community/group/create/',
  '/community/abc/details/p/',
  '/community/user/p/',
  '/community/group-details/p/',
  '/community/ranking/',
  '/community/member/p/',
  '/community/member-support/',
  '/community/group-support/',
  '/community/shop-support/',
  '/community/policy-privacy/',
  '/community/login-and-password/',
  '/community/account-support/',
  '/community/shop/course/checkout/p/',
  '/community/shop/course/p/',
  '/community/membership/shop/p/',
  '/community/shop/checkout/',
  '/community/shop/product-details/p/',
  '/community/course/p/',
  '/dashboard/analytics/',
  '/dashboard/ecommerce/',
  '/.well-known/apple-app-site-association'
];

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});
const location = JSON.parse(localStorage.getItem('location'));
const contactId = location && location.contactId;
const App = () => {

  // ** Get All Contacts
  const dispatch = useDispatch();
  const history = useHistory();
  //const store = useSelector(state=>state.socialCommunity)

  const [loc, setLoc] = useState(null);

  useEffect(() => {
    if (location && location !== null) {
      console.log("location",location)
      setLoc(location);
      dispatch(
        getCommunityDetailsAction({
          userId: location?.assignerId,
          organizationId: location?.organizationId
        })
      );
    }
  }, [location]);

  useEffect(() => {
    if (loc && loc !== null) {
      dispatch(getProfileAction(contactId));
    }
  }, [loc]);

  useEffect(() => {
    if (
      !urlsNotInclude.some(function (v) {
        return window.location.href.indexOf(v) >= 0;
      })
    ) {
      dispatch(fetchUserApi()).then((res) => {
        console.log('USER', res);
        if (res.error) {
          dispatch(handleLogout());
          if (!window.location.href.includes('login')) {
            console.log('redirect from here...... you will go to login page as token expired.');
            window.location.href = '/login';
          }
        } else {
          ls.init('dbe2cb7b.a4be30e4');
          ls.newPageView();
          ls.identify({
            name: res.payload.firstName,
            email: res.payload.auths.email
          });
          ls.setOptions({ keystrokes: true });
        }
      });
    }
    // else {
    //   if (
    //     window.location.href.includes('login') ||
    //     window.location.href.includes('signup') ||
    //     window.location.href.includes('register')
    //   ) {

    //     dispatch(handleLogout());
    //     //window.location.href = url
    //   }
    // }
  }, []);

  return (
    <QueryClientProvider client={client}>
      <SocketProvider>
        <Router />
      </SocketProvider>
    </QueryClientProvider>
  );
};

export default App;
